var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M20.25 5H3.75C2.95 5 2.25 5.7 2.25 6.5V17.5C2.25 18.3 2.95 19 3.75 19H20.25C21.05 19 21.75 18.3 21.75 17.5V6.5C21.75 5.7 21.05 5 20.25 5ZM20.25 17.5H3.75V9H20.25V17.5ZM20.25 7.5H3.75V6.5H20.25V7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M6.25 15.5C6.25 15.91 5.91 16.25 5.5 16.25H4.75C4.34 16.25 4 15.91 4 15.5V14.75C4 14.34 4.34 14 4.75 14H5.5C5.91 14 6.25 14.34 6.25 14.75V15.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M10.25 15.5C10.25 15.91 9.91 16.25 9.5 16.25H8.75C8.34 16.25 8 15.91 8 15.5V14.75C8 14.34 8.34 14 8.75 14H9.5C9.91 14 10.25 14.34 10.25 14.75V15.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M14.25 15.5C14.25 15.91 13.91 16.25 13.5 16.25H12.75C12.34 16.25 12 15.91 12 15.5V14.75C12 14.34 12.34 14 12.75 14H13.5C13.91 14 14.25 14.34 14.25 14.75V15.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/moneyIcon.7664d775ecf6638a06a4335a9e4dd762.svg";
export { ForwardRef as ReactComponent };